import { studentBookingClient } from '../client';

import { PaymentPlanServiceEndpoitns } from './constants';
import { CreatePaymentPlanDto } from './dto/CreatePaymentPlanDto';
import { PaymentPlanDto } from './dto/PaymentPlanDto';
import { mapPaymentPlanResponse } from './mappers';

export const createPaymentPlan = async (
    paymentPlanDetails: CreatePaymentPlanDto
): Promise<PaymentPlanDto> => {
    const { data: response } = await studentBookingClient.post(
        PaymentPlanServiceEndpoitns.PostCreatePaymentPlan,
        paymentPlanDetails
    );

    return mapPaymentPlanResponse(response.data);
};
